import React, { SVGProps } from 'react';

import { ReactComponent } from '../../assets/svg/person.svg';


export default (props: SVGProps<any>) => <ReactComponent {...props} />;

